// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var Sentry = require("../../../reason/Sentry.bs.js");
var Scalars = require("../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var PageTitle = require("../../../reason/common/PageTitle.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var MainLayout = require("../../../reason/common/components/MainLayout.bs.js");
var Responsive = require("../../../uikit/reason/helpers/Responsive.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Heading__Jsx3 = require("../../../uikit/reason/helpers/Heading__Jsx3.bs.js");
var MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var ErrorComponent = require("../../../reason/common/Error/ErrorComponent.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var PropertyWizardRelay = require("../propertyWizard/PropertyWizardRelay.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var Webapi__Dom__Document = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__Document.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardFormRelay = require("../propertyWizard/PropertyWizardFormRelay.bs.js");
var PropertyWizardRelayUtils = require("../propertyWizard/PropertyWizardRelayUtils.bs.js");
var MarkupHelpers$1 = require("components/MarkupHelpers");
var NewPropertyPageRelayFormData = require("./NewPropertyPageRelayFormData.bs.js");
var NewPropertyPageRelayQuery_graphql = require("../../../__generated__/NewPropertyPageRelayQuery_graphql.bs.js");
var NewPropertyPageRelay_query_graphql = require("../../../__generated__/NewPropertyPageRelay_query_graphql.bs.js");
var NewPropertyPageRelayRefetchQuery_graphql = require("../../../__generated__/NewPropertyPageRelayRefetchQuery_graphql.bs.js");
var NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql = require("../../../__generated__/NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.bs.js");

function NewPropertyPageRelay$Layout(props) {
  return JsxRuntime.jsx(MainLayout.make, {
              children: JsxRuntime.jsx(MarkupHelpers.Container.make, {
                    children: props.children
                  })
            });
}

var Layout = {
  make: NewPropertyPageRelay$Layout
};

function NewPropertyPageRelay$ErrorShowingDraft(props) {
  return JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
              children: JsxRuntime.jsx(ErrorComponent.make, {
                    message: "There was a problem getting the draft. Please refresh or try again later."
                  })
            });
}

var ErrorShowingDraft = {
  make: NewPropertyPageRelay$ErrorShowingDraft
};

var convertFragment = NewPropertyPageRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NewPropertyPageRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NewPropertyPageRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NewPropertyPageRelay_query_graphql.node, convertFragment, fRef);
}

var makeRefetchVariables = NewPropertyPageRelayRefetchQuery_graphql.Types.makeRefetchVariables;

var convertRefetchVariables = NewPropertyPageRelayRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(NewPropertyPageRelay_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

var DataFragment_draftV5Status_decode = NewPropertyPageRelay_query_graphql.Utils.draftV5Status_decode;

var DataFragment_draftV5Status_fromString = NewPropertyPageRelay_query_graphql.Utils.draftV5Status_fromString;

var DataFragment = {
  draftV5Status_decode: DataFragment_draftV5Status_decode,
  draftV5Status_fromString: DataFragment_draftV5Status_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable
};

var convertVariables = NewPropertyPageRelayQuery_graphql.Internal.convertVariables;

var convertResponse = NewPropertyPageRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = NewPropertyPageRelayQuery_graphql.Internal.convertWrapRawResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables, NewPropertyPageRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, NewPropertyPageRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(NewPropertyPageRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(NewPropertyPageRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(NewPropertyPageRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(NewPropertyPageRelayQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

var convertFragment$1 = NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(NewPropertyPageRelay_AlreadyPublishedProperty_property_graphql.node, convertFragment$1, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function NewPropertyPageRelay$AlreadyPublishedProperty(props) {
  var property = use$2(props.property);
  var id = property.id;
  if (id === undefined) {
    return JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {});
  }
  var onTanAt = property.onTanAt;
  var tmp;
  if (onTanAt !== undefined) {
    var match = property.propertyLocation;
    if (match !== undefined && match.__typename === "PropertyLocationWithVisibleAddress") {
      var address = match.address;
      if (address !== undefined) {
        var locationDisplay = match.locationDisplay;
        if (locationDisplay !== undefined) {
          var distanceFromNow = UTCDate.formatDistanceFromNow(true, Scalars.DateTime.toUTC(Caml_option.valFromOption(onTanAt)));
          tmp = JsxRuntime.jsxs(Text__Jsx3.make, {
                fontSize: {
                  NAME: "px",
                  VAL: 16
                },
                children: [
                  address + ", " + locationDisplay + " was published ",
                  distanceFromNow + " ago"
                ]
              });
        } else {
          tmp = null;
        }
      } else {
        tmp = null;
      }
    } else {
      tmp = null;
    }
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsxs(ViewStack.make, {
                      space: Responsive.make("sm", "md", undefined, undefined, undefined, undefined, undefined),
                      flexDirection: "column",
                      children: [
                        JsxRuntime.jsx(Heading__Jsx3.make, {
                              as_: "h2",
                              children: "This draft has already been published"
                            }),
                        tmp,
                        JsxRuntime.jsx(Text__Jsx3.make, {
                              fontSize: {
                                NAME: "px",
                                VAL: 16
                              },
                              children: "Do you wish to view the property's public page, edit the property, or start a new property draft?"
                            })
                      ]
                    }),
                JsxRuntime.jsxs(ViewStack.make, {
                      mt: "lg",
                      space: Responsive.make("sm", "md", undefined, undefined, undefined, undefined, undefined),
                      flexDirection: "row",
                      children: [
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              href: "/properties/" + id,
                              children: "VIEW"
                            }),
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              href: "/properties/" + id + "/edit",
                              children: "EDIT"
                            }),
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              href: "/properties/new",
                              children: "NEW"
                            })
                      ]
                    })
              ]
            });
}

var AlreadyPublishedProperty = {
  PropertyFragment: PropertyFragment,
  SecondaryButton: undefined,
  make: NewPropertyPageRelay$AlreadyPublishedProperty
};

function NewPropertyPageRelay$Inner(props) {
  var draftId = props.draftId;
  var data = use$1({
        hasDraftId: Core__Option.isSome(draftId),
        id: Core__Option.getOr(draftId, "")
      }, undefined, undefined, undefined);
  var match = React.useTransition();
  var startRefetchTransition = match[1];
  var match$1 = useRefetchable(data.fragmentRefs);
  var refetch = match$1[1];
  var agent = UserSession.useAgentInfo();
  var handleVisibilityChange = React.useCallback((function (_e) {
          var visibilityState = Webapi__Dom__Document.visibilityState(document);
          if (visibilityState === "Visible") {
            return startRefetchTransition(function () {
                        refetch({
                              hasDraftId: Core__Option.isSome(draftId),
                              id: Core__Option.getOr(draftId, "")
                            }, "network-only", undefined);
                      });
          }
          
        }), [
        startRefetchTransition,
        refetch,
        draftId
      ]);
  React.useEffect((function () {
          document.addEventListener("visibilitychange", handleVisibilityChange);
          return (function () {
                    document.removeEventListener("visibilitychange", handleVisibilityChange);
                  });
        }), [handleVisibilityChange]);
  var match$2 = match$1[0].draftV5;
  var tmp;
  if (match$2 !== undefined) {
    switch (match$2.__typename) {
      case "DraftV5" :
          if (match$2.chapter !== undefined) {
            var match$3 = match$2.status;
            var exit = 0;
            if (match$3 !== undefined && (match$3 === "PUBLISHED" || match$3 === "EXPIRED" || match$3 === "DRAFT" || match$3 === "DELETED" || match$3 === "RESUMABLE_DRAFT")) {
              switch (match$3) {
                case "DELETED" :
                    tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                          children: JsxRuntime.jsx(MarkupHelpers$1.ContentBox, {
                                hasShadow: true,
                                children: "This draft has been deleted"
                              })
                        });
                    break;
                case "EXPIRED" :
                    tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                          children: JsxRuntime.jsx(MarkupHelpers$1.ContentBox, {
                                hasShadow: true,
                                children: "This draft has expired"
                              })
                        });
                    break;
                default:
                  exit = 1;
              }
            } else {
              exit = 1;
            }
            if (exit === 1) {
              tmp = JsxRuntime.jsx(PropertyWizardRelay.make, {
                    draftData: NewPropertyPageRelayFormData.toDraftData(match$2.fragmentRefs),
                    draftDbId: match$2.databaseId
                  });
            }
            
          } else {
            Sentry.captureErrorMessage("Missing chapter timeZone in new property page", true, undefined, "NewPropertyPageRelay.res", 168, {
                  currentUser: agent
                }, undefined, undefined);
            tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                  children: JsxRuntime.jsx(ErrorComponent.make, {
                        message: "We encountered a problem while loading your account settings... Please refresh or try again later"
                      })
                });
          }
          break;
      case "NotAuthorizedError" :
          tmp = JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                children: JsxRuntime.jsx(ErrorComponent.make, {
                      message: "The draft with id " + Core__Option.getOr(draftId, "-") + " does not belong to you"
                    })
              });
          break;
      case "PublishedPropertyDraft" :
          var property = match$2.property;
          tmp = property !== undefined ? JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                  children: JsxRuntime.jsx(MarkupHelpers$1.ContentBox, {
                        paddingFull: true,
                        hasShadow: true,
                        children: Caml_option.some(JsxRuntime.jsx(NewPropertyPageRelay$AlreadyPublishedProperty, {
                                  property: property.fragmentRefs
                                }))
                      })
                }) : JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {});
          break;
      case "NotFoundError" :
      case "__unselected" :
          tmp = JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {});
          break;
      
    }
  } else {
    tmp = draftId !== undefined ? JsxRuntime.jsx(NewPropertyPageRelay$ErrorShowingDraft, {}) : JsxRuntime.jsx(PropertyWizardRelay.make, {});
  }
  return JsxRuntime.jsxs(PropertyWizardFormRelay.Context.Provider.make, {
              mode: React.useMemo((function () {
                      return "New";
                    }), []),
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Broadcast Property"
                    }),
                tmp
              ]
            });
}

var Inner = {
  make: NewPropertyPageRelay$Inner
};

function NewPropertyPageRelay(props) {
  var match = PropertyWizardRelayUtils.QueryParams.use();
  var draftId = match[0].draftId;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(PageTitle.make, {
                      title: "Broadcast Property"
                    }),
                JsxRuntime.jsx(React.Suspense, {
                      children: Caml_option.some(JsxRuntime.jsx(NewPropertyPageRelay$Inner, {
                                draftId: draftId
                              })),
                      fallback: Caml_option.some(JsxRuntime.jsx(NewPropertyPageRelay$Layout, {
                                children: JsxRuntime.jsx(View__Jsx3.make, {
                                      my: "lg",
                                      children: Caml_option.some(JsxRuntime.jsx(Loader.make, {}))
                                    })
                              }))
                    })
              ]
            });
}

var QueryParams;

var $$Document;

var make = NewPropertyPageRelay;

var $$default = NewPropertyPageRelay;

exports.QueryParams = QueryParams;
exports.$$Document = $$Document;
exports.Layout = Layout;
exports.ErrorShowingDraft = ErrorShowingDraft;
exports.DataFragment = DataFragment;
exports.Query = Query;
exports.AlreadyPublishedProperty = AlreadyPublishedProperty;
exports.Inner = Inner;
exports.make = make;
exports.default = $$default;
exports.__esModule = true;
/* use Not a pure module */
